import { render, staticRenderFns } from "./ShiftBookedStatus.vue?vue&type=template&id=cf6bb302&"
import script from "./ShiftBookedStatus.vue?vue&type=script&lang=ts&"
export * from "./ShiftBookedStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
